export default __webpack_public_path__ + "graphics/concert.735bfb04.jpg";